var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 96.508,
    height: 52.002,
    viewBox: "0 0 96.508 52.002",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uB808\\uC774\\uC5B4_2",
    "data-name": "\\uB808\\uC774\\uC5B4 2",
    transform: "translate(-0.007)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uB808\\uC774\\uC5B4_1",
    "data-name": "\\uB808\\uC774\\uC5B4 1",
    transform: "translate(0.007)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_1",
    "data-name": "\\uD328\\uC2A4 1",
    d: "M38.36,23.9a9.155,9.155,0,1,0-9.15-9.169A9.155,9.155,0,0,0,38.36,23.9Zm0-12.97a3.815,3.815,0,1,1-3.815,3.815A3.815,3.815,0,0,1,38.36,10.931Z",
    transform: "translate(-15.457 -2.957)",
    fill: "#b2b2b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2",
    "data-name": "\\uD328\\uC2A4 2",
    d: "M41.485,61.667a29.359,29.359,0,0,1-15.9,6.4V54.584a2.67,2.67,0,1,0-5.336,0V68.063a29.359,29.359,0,0,1-15.9-6.4A2.667,2.667,0,0,0,1.007,65.83a34.7,34.7,0,0,0,21.9,7.691A34.709,34.709,0,0,0,44.819,65.83a2.667,2.667,0,0,0-3.334-4.163Z",
    transform: "translate(-0.007 -27.406)",
    fill: "#b2b2b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3",
    "data-name": "\\uD328\\uC2A4 3",
    d: "M153.972,16.634H136.707A2.637,2.637,0,0,1,134.07,14V2.637a2.637,2.637,0,0,1,5.275,0v8.722h14.628a2.637,2.637,0,0,1,0,5.275Z",
    transform: "translate(-70.933)",
    fill: "#b2b2b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_4",
    "data-name": "\\uD328\\uC2A4 4",
    d: "M151.107,48.165H110.817a2.637,2.637,0,1,1,0-5.275h40.289a2.637,2.637,0,1,1,0,5.275Z",
    transform: "translate(-57.236 -22.691)",
    fill: "#b2b2b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_5",
    "data-name": "\\uD328\\uC2A4 5",
    d: "M141.241,84.629A29.173,29.173,0,0,1,129.2,82.18a2.633,2.633,0,0,1-1.474-2.355v-7.6a2.637,2.637,0,0,1,2.637-2.637h19.238V66.945H130.367a2.637,2.637,0,1,1,0-5.275h21.875a2.637,2.637,0,0,1,2.637,2.637v7.917a2.637,2.637,0,0,1-2.637,2.637H133v3.155a26.505,26.505,0,0,0,18.244-.65,2.637,2.637,0,0,1,1.987,4.884A31.633,31.633,0,0,1,141.241,84.629Z",
    transform: "translate(-67.579 -32.627)",
    fill: "#b2b2b2"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo2);
export default __webpack_public_path__ + "static/media/logo2.3f737c782ba3f7bfcdecd376578a2925.svg";
export { ForwardRef as ReactComponent };